export const APP_UPDATE_CHECK_INTERVAL = 60 * 60 * 1000
